import { render } from "./UHC_ColonCancer.vue?vue&type=template&id=12c2aef4&scoped=true"
import script from "./UHC_ColonCancer.vue?vue&type=script&lang=js"
export * from "./UHC_ColonCancer.vue?vue&type=script&lang=js"

import "./UHC_ColonCancer.vue?vue&type=style&index=0&id=12c2aef4&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c2aef4"]])

export default __exports__